var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMirrorPortraitInner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 260,
    height: 342
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M208.337 0H51.662a3.835 3.835 0 00-3.207 1.759A112.717 112.717 0 012.248 41.73a3.823 3.823 0 00-2.249 3.467v251.619a3.822 3.822 0 002.248 3.467 112.631 112.631 0 0146.208 39.973 3.839 3.839 0 003.207 1.745h156.675a3.837 3.837 0 003.206-1.745 112.584 112.584 0 0146.222-39.973 3.824 3.824 0 002.235-3.467V45.197a3.828 3.828 0 00-2.235-3.467 112.674 112.674 0 01-46.222-39.971A3.834 3.834 0 00208.337 0z",
    fill: "#003c3b"
  })));
}

export default __webpack_public_path__ + "718e602966d554a3c6f6cd12b8ed7f62.svg";
export { SvgMirrorPortraitInner as ReactComponent };